var _path, _circle, _circle2, _circle3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFilters(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 13.764V3h-2v10c.768 0 1.47.289 2 .764zm0 4.472A2.989 2.989 0 0111 19v2h2v-2.764zM20 8V3h-2v2.17c1.165.413 2 1.524 2 2.83zm-2 2.83A3.001 3.001 0 0020 8v13h-2V10.83zM6 6.17V3H4v3.17a2.994 2.994 0 012 0zm0 5.66a2.994 2.994 0 01-2 0V21h2v-9.17z",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 9,
    r: 2,
    fill: "transapent",
    stroke: "currentColor",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 16,
    r: 2,
    fill: "transparent",
    stroke: "currentColor",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 8,
    r: 2,
    fill: "transparent",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMyAxMy43NjM5VjNIMTFWMTNDMTEuNzY4MyAxMyAxMi40NjkyIDEzLjI4ODggMTMgMTMuNzYzOVpNMTMgMTguMjM2MUMxMi40NjkyIDE4LjcxMTIgMTEuNzY4MyAxOSAxMSAxOVYyMUgxM1YxOC4yMzYxWiIgZmlsbD0iY3VycmVudENvbG9yIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMjAgOFYzSDE4VjUuMTcwNjVDMTkuMTY1MiA1LjU4MjUyIDIwIDYuNjkzNzMgMjAgOFpNMTggMTAuODI5M0MxOS4xNjUyIDEwLjQxNzUgMjAgOS4zMDYyNyAyMCA4VjIxSDE4VjEwLjgyOTNaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02IDYuMTcwNjVWM0g0VjYuMTcwNjVDNC4zMTI3NCA2LjA2MDA2IDQuNjQ5NDEgNiA1IDZDNS4zNTA1OSA2IDUuNjg3MjYgNi4wNjAwNiA2IDYuMTcwNjVaTTYgMTEuODI5M0M1LjY4NzI2IDExLjkzOTkgNS4zNTA1OSAxMiA1IDEyQzQuNjQ5NDEgMTIgNC4zMTI3NCAxMS45Mzk5IDQgMTEuODI5M1YyMUg2VjExLjgyOTNaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPGNpcmNsZSBjeD0iNSIgY3k9IjkiIHI9IjIiIGZpbGw9InRyYW5zYXBlbnQiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjIiLz4KPGNpcmNsZSBjeD0iMTIiIGN5PSIxNiIgcj0iMiIgZmlsbD0idHJhbnNwYXJlbnQiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjIiLz4KPGNpcmNsZSBjeD0iMTkiIGN5PSI4IiByPSIyIiBmaWxsPSJ0cmFuc3BhcmVudCIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMiIvPgo8L3N2Zz4K";
export { SvgFilters as ReactComponent };